export const API_URI = `https://help-rope-backend.appspot.com/api/v1/`;
export const USER = `user`;
export const MEAL_REQUESTS = `applications`;
